import React from "react";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import Seo from "../components/Seo";

const InteriorDecals = () => {
  return (
    <div className="page-shell" data-theme="interior-decals">
      <Seo
        title="J3 Interior Decals in Kingwood | J3 Innovations"
        description="J3 Interior Decals in Kingwood and Houston: painted graphics with masking-film stencils, skim-coated walls, and crisp lines."
        canonicalPath="/interior-decals"
        image="/logo192.png"
      />
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">Flagship System</p>
          <h1>J3 Interior Decals™</h1>
          <p className="lead">Painted like murals. Placed like decals.</p>
          <div className="pill-row">
            <span className="pill">Masking-film stencils</span>
            <span className="pill">Skim-coated walls</span>
            <span className="pill">Caulk-sealed edges</span>
          </div>
          <div className="cta-row">
            <Link to="/quote" className="btn primary">
              Tell us about your wall
            </Link>
            <Link to="/fast-flash" className="btn ghost">
              Need a fast refresh?
            </Link>
          </div>
        </div>

        <div className="section-block">
          <h2>What this is</h2>
          <p>
            High-end painted interior graphics built from masking-film stencils
            — not peel-and-stick vinyl. Each wall is skimmed smooth, aligned to
            the room’s sightlines, and finished with crisp paint lines that feel
            built-in, not slapped on.
          </p>
        </div>

        <div className="section-block">
          <h2>Who it’s for</h2>
          <div className="bullet-grid">
            <div className="bullet-card">
              <h3>Airbnb / rentals</h3>
              <ul>
                <li>Photo-ready “wow” walls that survive turnovers.</li>
                <li>Memorable backdrops without high-maintenance trim.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Busy families</h3>
              <ul>
                <li>Signature rooms without betting a weekend on DIY.</li>
                <li>Durable, cleanable paint systems.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Home offices / creators</h3>
              <ul>
                <li>Intentional backgrounds that read well on camera.</li>
                <li>Repeatable patterns, precise placement.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="section-block">
          <h2>Why it beats DIY & stickers</h2>
          <div className="bullet-grid">
            <div className="bullet-card">
              <h3>Prep that holds</h3>
              <ul>
                <li>Straight, smooth, skim-coated walls before any design.</li>
                <li>Primers and paints chosen for the room, not a video.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Placement that respects the room</h3>
              <ul>
                <li>Masking film aligned with grids and sightlines.</li>
                <li>Transfer tape for true-to-file positioning.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Edges that stay crisp</h3>
              <ul>
                <li>Caulk-sealed stencil edges — no bleed, no fuzz.</li>
                <li>Painted graphics that feel permanent, not stickered.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="section-block">
          <h2>How it works</h2>
          <div className="steps">
            <div className="step">
              <strong>Step 1:</strong> Send photos and rough wall dimensions.
            </div>
            <div className="step">
              <strong>Step 2:</strong> Choose a design or direction — we prep the file.
            </div>
            <div className="step">
              <strong>Step 3:</strong> We schedule install and handle prep, stencil, and paint.
            </div>
          </div>
        </div>

        <div className="quote-box">
          <h2>Ready for a wall that earns its space?</h2>
          <p>
            Tell us about your room and we’ll map the stencil, paint system, and install
            timeline. We respect the house, the craft, and your weekend.
          </p>
          <Link to="/quote" className="btn primary">
            Request a free walkthrough
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InteriorDecals;
